import React from 'react'

export const renderField_w100 = ({ input, placeholder, label, icon, type, meta: { touched, error, warning } }) => (
  <div className='dt-inputForm-block dt-inputForm-block-fix-width-100'>
    <div className='dt-inputText'>{label}</div>
    <div className={icon}>
      <textarea {...input} placeholder={placeholder} type={type} className='dt-input dt-input-fix'></textarea>
    </div>
    {touched ? ((error && <span className='dt-inputMessage --show'>{error}</span>) || (warning && <span className='dt-inputMessage --show'>{warning}</span>)) : <span className='dt-inputMessage' />}
  </div>
)
